import { FunctionComponent, useEffect, useState } from "react";

import { InputText } from "primereact/inputtext";

interface ISettingTextInputProps {
  value: string;
  onChange: (value: string) => void;
  validationFunction?: (value: string) => boolean;
  style?: React.CSSProperties;
}

export const SettingTextInput: FunctionComponent<ISettingTextInputProps> = (props: ISettingTextInputProps) => {
  const isValidText = (text: string) => {
    return props.validationFunction ? props.validationFunction(text) : true;
  };

  const [value, setValue] = useState<string>(props.value);
  const [isValid, setIsValid] = useState<boolean>(true);

  useEffect(() => {
    if (props.value !== value) {
      setValue(props.value);
    }
  }, [props.value]);

  const onTextInputChange = (value: string) => {
    setValue(value);

    if (isValidText(value)) {
      props.onChange(value);
    }
  };

  useEffect(() => {
    setIsValid(isValidText(value));
  }, [value]);

  return (
    <InputText
      onChange={event => onTextInputChange(event.target.value)}
      value={value}
      className={`${isValid ? "p-valid" : "p-invalid"}`}
      style={props.style}
    />
  );
};
